import * as THREE from "three";
import { useEffect, useRef, useState } from "react";
import { Html } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { ILocation } from "../models/general.model";
import { Typography } from "@mui/material";
import { IHotspot } from "../models/hotspot.model";
import { useControls } from "leva";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import info from "../components/assets/info.svg";
import { InfoModel } from "./InfoModel";
import Paper from "@mui/material/Paper/Paper";
import AppPrimaryButton from "../appComponents/buttons/AppPrimaryButton";
import CloseRounded from "@mui/icons-material/CloseRounded";
import IconButton from "@mui/material/IconButton";
import InformationModal from "../components/layouts/InformationModal";
import { InfoOutlineModel } from "./InfoOutlineModel";
import { ComingSoonModel } from "./ComingSoonModel";
import { Text } from "@react-three/drei";

type GLTFResult = GLTF & {
  nodes: {
    Circle: THREE.Mesh;
    Circle001: THREE.Mesh;
  };
  materials: {
    ["Material.001"]: THREE.MeshStandardMaterial;
  };
};

interface IProps {
  hotspot: IHotspot;
  clicked: string;
  setClicked: any;
  clickedOpen: any;
}

export function ComingSoon({
  hotspot,
  clicked,
  setClicked,
  clickedOpen,
}: IProps) {
  // const controller = useControls({
  //   [`${hotspot.id}-x`]: { value: hotspot.position.x, min: -100, max: 100 },
  //   [`${hotspot.id}-y`]: { value: hotspot.position.y, min: -100, max: 100 },
  //   [`${hotspot.id}-z`]: { value: hotspot.position.z, min: -100, max: 100 },

  //   [`${hotspot.id}-scale`]: { value: hotspot.scale, min: -100, max: 100 },

  //   // [`${hotspot.id}-r-x`]: {
  //   //   value: hotspot.rotation.x,
  //   //   min: -360,
  //   //   max: 360,
  //   // },
  //   // [`${hotspot.id}-r-y`]: {
  //   //   value: hotspot.rotation.y,
  //   //   min: -360,
  //   //   max: 360,
  //   // },
  //   // [`${hotspot.id}-r-z`]: {
  //   //   value: hotspot.rotation.z,
  //   //   min: -360,
  //   //   max: 360,
  //   // },
  // });

  const [open, setOpen] = useState(false);

  const ref: any = useRef();

  useEffect(() => {
    if (ref.current) {
      ref.current.lookAt(0, 0, 0);
    }
  }, []);

  return (
    <group
      position={[
        // controller[`${hotspot.id}-x`],
        // controller[`${hotspot.id}-y`],
        // controller[`${hotspot.id}-z`],
        hotspot.position.x,
        hotspot.position.y,
        hotspot.position.z,
      ]}
    >
      {/* {open && (
        <mesh
          position={[
            // controller[`${hotspot.id}-x`],
            // controller[`${hotspot.id}-y`] + 20,
            // controller[`${hotspot.id}-z`],
            0, 12, 0,
          ]}
        >
        
        </mesh>
      )} */}
      {/* 
      {open && (
        <Text
          color="black"
          anchorX="center"
          anchorY="middle"
          position={[0, 0, 0]}
          fontSize={10}
          ref={ref}
        >
          hello world!
        </Text>
      )} */}

      <ComingSoonModel
        open={open}
        setOpen={setOpen}
        onClick={() => clickedOpen(hotspot)}
        position={[
          0, 0, 0,
          // hotspot.position.x,
          // hotspot.position.y,
          // hotspot.position.z,
        ]}
        scale={hotspot.scale}
        setModalOpen={setOpen}
      />
    </group>
  );
}
